import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { Router, Switch, Route } from 'react-router-dom'
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducers from './reducers'
import history from './history'
import './styles/style.css';
import App from './containers/App'
import Login from './containers/Login'

const store = createStore(reducers, applyMiddleware(thunk))
if(process.env.NODE_ENV === 'development'){
  store.subscribe(() =>
    console.log(store.getState())
  )
}

render(
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        <Route exact path='/login' component={Login}/>
        <Route path='/' component={App}/>
      </Switch>
    </Router>
  </Provider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js